<template lang="pug">
  footer
    .footer-main
      .footer-main-wrap.container.mx-auto
        .grid-box
          .box.box-1
            h4 {{ this.CMS.name }}
            p Tel.: <a href="tel:00492161576580">02161 – 576 58 0</a> <br>
            | Fax: <a href="fax:004921615765818">02161 – 576 58 18</a> <br>
            | E-Mail: <a href="mailto:info@lse-software.de">info@lse-software.de</a>
          .box.box-2
            h4 Support-Zeiten
            p Mo-Do: 09:00 bis 13:00 Uhr <br>
            | Mo-Do: 14:00 bis 17:00 Uhr <br>
            | Fr: 09:00 bis 14:30 Uhr
          .box.box-3
            h4 E-Commerce
            Menu.footer-menu#footer-menu-ecommerce(
                k="footer-menu-ecommerce" 
                :max-depth="1"
              )
          .box.box-4
            h4 Rechtliches
            Menu.footer-menu#footer-menu-rechtliches(
                k="footer-menu-rechtliches" 
                :max-depth="1"
              )


    .copyright 
      .container.mx-auto
        p &copy; {{ new Date().getFullYear() }} LSE-Software GmbH

    transition(name="fade")
      div#to-top(@click="toTop" v-if="scY > 50")
        font-awesome-icon(icon="angle-up") 

</template>

<script>
import { mapGetters } from 'vuex';
import Menu from '@/components/Menu.vue';

export default {
    name: 'Footer',
    components: {
        Menu
    },
    data() {
        return {
            scTimer: 0,
            scY: 0
        };
    },
    computed: {
        ...mapGetters({
            CMS: 'CMS',
            menus: 'menus',
            config: 'config'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll: function() {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        toTop: function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply block bottom-0 w-full
  .footer-main
    @apply text-white p-6
    background-color: #252525

    @screen sm
      padding: 3.438rem 0
    .footer-main-wrap
      @apply flex justify-between
      .grid-box
        @apply flex justify-between w-full flex-wrap
        @screen lg
          flex-wrap: nowrap
        > div:first-of-type
          @apply ml-0
        > div:last-of-type
          @apply mr-0
        .box
          @apply text-xs leading-6 my-2
          width: 100%
          @screen sm
            width: 50%
          @screen lg
            @apply mx-12 my-0
          h4
            @apply font-bold mb-3
            font-size: 0.875rem
          &::v-deep a:hover
            text-decoration: underline
  .copyright
    @apply text-white bg-black text-xs text-left py-5
    line-height: 22px

  div#to-top
    @apply fixed text-center transition duration-500 ease-in-out cursor-pointer text-white bg-black bg-opacity-25
    width: 29px
    height: 29px
    line-height: 29px
    bottom: 17px
    right: 17px
    z-index: 200
    &:hover
      background-color: $color-primary

  .fade-enter,
  .fade-leave-to
    opacity: 0

  .fade-enter-active,
  .fade-leave-active
    transition: opacity .5s



</style>
